// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setCustomPDFReportBuilderStore = createAction('[Custom PDF Report Builder] Set Report Builder Store', props());
